import React, { useState } from "react";
import { Layers } from "lucide-react";
import { useAuth, canEditAssociation } from "../contexts/AuthContext";
import PlanYearsDrawer from "./PlanYearsDrawer";
import NewPlanYearWizard from "./NewPlanYearWizard";

// "Plan Year nnnn" pill (Dashboard · Results at a Glance) — opens the Plan
// Years drawer (view / reactivate / start new). Moved from the Association tab.
export function PlanYearPill({ association, onChanged, label, testId = "raag-plan-year-pill", className, style, iconFirst = false }) {
  const { user } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);
  const editable = canEditAssociation(user, association?.tenant_id, association?.aid);
  if (association?.study_year == null) return null;

  return (
    <>
      <button
        onClick={() => setDrawerOpen(true)}
        className={className || "inline-flex items-center gap-1 border border-navy bg-white text-navy hover:bg-navy-wash px-2 py-0.5 text-[11px] font-semibold rounded-[3px]"}
        style={style}
        data-testid={testId}
        title="View, reactivate, or start a new plan year"
      >
        {iconFirst && <Layers size={12} />}
        {label || `Plan Year ${association.study_year}`}
        {!iconFirst && <Layers size={11} />}
      </button>
      {drawerOpen && (
        <PlanYearsDrawer
          association={association}
          canEdit={editable}
          onClose={() => setDrawerOpen(false)}
          onChanged={() => onChanged?.(association)}
          onNewPlanYear={() => {
            setDrawerOpen(false);
            setWizardOpen(true);
          }}
        />
      )}
      {wizardOpen && (
        <NewPlanYearWizard
          association={association}
          onClose={() => setWizardOpen(false)}
          onCreated={() => onChanged?.(association)}
        />
      )}
    </>
  );
}
